import React from 'react';

const Legal = ({ title }) => {
  return (
    <div className="bg-white min-h-screen py-16">
      <div className="container-custom max-w-3xl prose prose-slate">
        <h1 className="text-3xl font-bold mb-8">{title}</h1>
        
        {title === 'Impressum' && (
          <div className="space-y-6">
            <section>
              <h2 className="text-xl font-bold mb-3">Angaben gemäß § 5 TMG</h2>
              <p className="text-slate-600">
                <strong>Nebenjob Nord</strong><br />
                Axel-Springer-Platz 3<br />
                20355 Hamburg
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold mb-3">Vertreten durch</h2>
              <p className="text-slate-600">Daniel Avendi</p>
            </section>

            <section>
              <h2 className="text-xl font-bold mb-3">Kontakt</h2>
              <p className="text-slate-600">
                E-Mail: info@nebenjob-nord.de
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold mb-3">Haftungsausschluss</h2>
              <p className="text-slate-600 leading-relaxed">
                Nebenjob Nord ist eine Vermittlungsplattform. Die konkrete Beschäftigung, Vergütung und Vertragsgestaltung erfolgt zwischen Bewerber und Unternehmen, sofern nicht ausdrücklich anders vereinbart. Wir übernehmen keine Haftung für die Inhalte externer Links.
              </p>
            </section>
          </div>
        )}

        {title === 'Datenschutz' && (
          <div className="space-y-6">
            <h2 className="text-xl font-bold mb-3">Datenschutzerklärung</h2>
            <p className="text-slate-600 leading-relaxed">
              Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
            </p>
            
            <h3 className="text-lg font-bold mb-2">Datenerfassung auf unserer Website</h3>
            <p className="text-slate-600 leading-relaxed">
              Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Wenn Sie unsere Formulare nutzen (Bewerber oder Unternehmen), werden die von Ihnen eingegebenen Daten zur Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung an Dritte weiter, außer es dient dem ausdrücklichen Zweck der Vermittlung an passende Unternehmen (nach Ihrer Zustimmung im Formular).
            </p>
            
            <h3 className="text-lg font-bold mb-2">Zweck der Vermittlung</h3>
            <p className="text-slate-600 leading-relaxed">
              Bewerberdaten werden ausschließlich zum Zweck der Jobvermittlung erhoben. Mit Absenden des Bewerbungsformulars stimmen Sie zu, dass Ihre Daten an potenzielle Arbeitgeber weitergegeben werden dürfen.
            </p>
            
            <p className="text-slate-500 italic text-sm border-t pt-4">
              (Hinweis: Dies ist ein Platzhaltertext für das Template. Ein vollständiges, rechtsgültiges Impressum und eine Datenschutzerklärung müssen vor Live-Schaltung ergänzt werden.)
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Legal;